import { useParams, Navigate } from "react-router-dom";

export default function RedirectNews() {
  const { storyID, title } = useParams();

  return <Navigate to={`/${storyID}/${title}`} replace />;
}
